import { Stripe, loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from 'utils/envUtils';

class StripeService {
  private static instances: Map<string, Promise<Stripe | null>> = new Map();

  /**
   * Get or create a Stripe instance for the given account
   * @param accountId - Optional Stripe Connect account ID
   * @returns Promise that resolves to Stripe instance or null
   */
  static getInstance(accountId?: string): Promise<Stripe | null> {
    const key = accountId || 'default';

    if (!this.instances.has(key)) {
      const options = accountId ? { stripeAccount: accountId } : undefined;
      const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY, options);
      this.instances.set(key, stripePromise);
    }

    return this.instances.get(key)!;
  }

  /**
   * Clear a specific Stripe instance
   * @param accountId - Optional Stripe Connect account ID
   */
  static clearInstance(accountId?: string): void {
    const key = accountId || 'default';
    this.instances.delete(key);
  }

  /**
   * Clear all Stripe instances
   * Useful for cleanup when user logs out or switches teams
   */
  static clearAllInstances(): void {
    this.instances.clear();
  }

  /**
   * Get the number of active Stripe instances
   * Useful for debugging and monitoring
   */
  static getInstanceCount(): number {
    return this.instances.size;
  }
}

export default StripeService;
